import { Mui } from "@osu/react-ui";

export default function ManageAppTabs({ tabs, showTab, closeTab }) {
    const xBtnStyle = { fontSize: "15px", cursor: "pointer", top: "-1px", position: "relative" };
    
    function closeTabFn(event) {
        const index = this;
        event.stopPropagation();
        closeTab(index);
    }
    
    return (        
        <Mui.Tabs
            value={tabs.findIndex(tab => tab.selected)}
            onChange={(_event, newValue) => { showTab(newValue); }}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ "& .MuiTabs-indicator": { height: "3px" }} // Make the underline thicker
        }>
            {tabs.map((tab, index) => { return (
                <Mui.Tab
                    key={index}
                    label={
                        <Mui.Box sx={{ display: "flex", alignItems: "center" }}>
                            {tab.label}
                            {index !== 0 && (
                                <Mui.IconButton onClick={closeTabFn.bind(index)} component="span">
                                    <Mui.Icon sx={xBtnStyle}>X</Mui.Icon>
                                </Mui.IconButton>
                            )}
                        </Mui.Box>
                    }
                />
            )})}
        </Mui.Tabs>
    );
}